import Auth from 'store/auth'
import useSocketConnection from './useSocketConnection'

import { WEBINAR_SERVICE_URL } from 'constants/data'
import { ISocket } from 'constants/types/statistic-socket.types'

const url = `${WEBINAR_SERVICE_URL}/socket.io`

const useWebinarSocket = (webinarId: number): ISocket => {
  const { accessToken, isAuthorized, userProfile } = Auth.useAuth()

  const { socketHolder } = useSocketConnection(url, { accessToken, webinarId }, [
    isAuthorized,
    webinarId,
    userProfile,
  ])

  return socketHolder
}

export default useWebinarSocket
